import React from "react";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Cytat() {
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          {/* <div className='col'> */}
          <div className='cytat'>
            <div className='text1'>
              "Największym odkryciem mojego pokolenia jest to, że ludzie mogą
              zmieniać swoje życie, zmieniając nastawienie swojego umysłu“
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
